
const $ = window.jQuery;
const GoogleAdsScripts = {

    init() {
        $(document).bind("gform_confirmation_loaded", function (event, formID) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "formSubmission",
                formID: formID,
            });
        });
    },

};

export default GoogleAdsScripts;